<template>
    <div>
        <transition name="el-fade-in" mode="out-in">
            <router-view/>
        </transition>
        <div v-if="!splashed">
            <el-dialog
                    width="310px"
                    top="120px"
                    :show-close="true"
                    :visible="visibleTrial"
                    :before-close="toggleTrial"
                    :close-on-click-modal="false"
                    close-on-press-escape
                    modal>
                <div>
                    <h2 class="text-center">{{ trialDays }} days remaining in trial!</h2>
                    <a :href="$urls.SUPPORT_TUTORIALS" target="_blank">
                        <el-button type="warning" round class="w-100">Open Tutorials</el-button>
                    </a>
                    <hr style="margin: 1.5rem 0;">
                    <h3 class="text-center">Upgrade for uninterrupted access</h3>
                    <a :href="$urls.USER_ACCOUNT_BILLING">
                        <el-button type="primary" round class="w-100">Add Payment Info</el-button>
                    </a>
                    <a :href="$urls.USER_ACCOUNT_USERS" class="d-block my-3">
                        <el-button type="primary" round class="w-100">Upgrade Membership</el-button>
                    </a>
                </div>
            </el-dialog>
            <SplashScreen @load="handleSplashLoad"/>
        </div>
    </div>
</template>

<script>
  import SplashScreen from "../components/SplashScreen";
  import { displayRoute } from "../config/router";
  import { store } from "../store";

  export default {
    name: "GearsApp",
    components: {SplashScreen},

    data() {
      return {
        splashed: process.env.NODE_ENV === 'development',
        visibleTrial: false,
      }
    },
    computed: {
      usingTrial() {
        return this.$store.state.session.usingTrial;
      },
      trialDays() {
        return Math.round(this.$store.state.session.trialDays);
      },
    },
    mounted() {
      // show trial dialog
      if (this.usingTrial) {
        setTimeout(() => {
          this.visibleTrial = true
        }, 2000);
      }
    },
    methods: {
      handleSplashLoad() {
        // prevent displaying splash screen again until a page refresh
        this.splashed = true;
      },
      toggleTrial() {
        this.visibleTrial = !this.visibleTrial;
      }
    },
    beforeRouteEnter(to, from, next) {
      // Called before the route that renders this component is confirmed.
      // Does NOT get called when route that renders this component has changed, see beforeRouteUpdate.
      // Does NOT have access to `this` component instance, except in next() callback.

      // PLACEHOLDER {mobile} add mobile compatible views to for the following router endpoints:
      //  /models                       [FileExplorer.vue]  Display models.
      //  /model/:modelId               [Modeling.vue]      Display 3D & AR.
      //  /model/:modelId/v/:versionId  [Modeling.vue]      Display 3D & AR.

      const isDesktop = window.matchMedia("only screen and (min-width: 900px)").matches;

      if (!isDesktop) {
        displayRoute({name: 'mobile'});
      } else {
        // server handles authentication and authorization
        // Apollo error handler considers HTTP response code to display error page or redirect
        store.dispatch('queryUser').then(next);
      }
    },
  }
</script>


<style>
    /*DO NOT MAKE STYLE SCOPED*/
    body {
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    :root {
        /*TABS*/
        --get-tab-height: 38px;

        /*RIBBON*/
        --ribbon-height: 105px;
        --btn-bar-group-spacing: 1.5em;

        /*BROWSER*/
        --browser-width: 300px;

        /*MISC*/
        --grid-col-padding: 2em;

        /*ALSO SEE: dialog.css*/
    }
</style>
